export default {"src":"/uk/_next/static/media/beeIcon.69edcb02.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};